<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" ref="searchForm" label-width="85px">
        <el-form-item label="工号">
          <el-input v-model.trim="form.workNo" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.userName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="店铺全称">
          <el-select v-model="form.storeFullName" placeholder="请选择" clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in storeList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台客服ID">
          <el-input v-model.trim="form.platCustomerServiceId" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="岗位">
          <el-select v-model="form.workJobs" placeholder="请选择" clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in workJobsList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服等级">
          <el-select v-model="form.customerServiceLevel" placeholder="请选择" clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in customerServiceLevelList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <el-button type="primary" size="small" @click="delRow(false)">删除</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        :height="maxTableHeight"
        @selection-change="handleSelectionChange"
        row-key="dataId"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true" fixed="left"></el-table-column>
        <el-table-column label="平台" prop="platformName" min-width="80px" show-overflow-tooltip></el-table-column>
        <el-table-column label="店铺全称" prop="storeFullName" min-width="150px" show-overflow-tooltip></el-table-column>
        <el-table-column label="平台客服ID" prop="platCustomerServiceId" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column label="全称客服ID" prop="serviceUserIdFull" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column label="真实姓名" prop="userName" show-overflow-tooltip></el-table-column>
        <el-table-column label="岗位" prop="workJobs" show-overflow-tooltip></el-table-column>
        <el-table-column label="工号" prop="workNo" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column label="责任部门" prop="responsibleDepartment" show-overflow-tooltip></el-table-column>
        <el-table-column label="公司名称" prop="companyName" show-overflow-tooltip></el-table-column>
        <el-table-column label="客服等级" prop="customerServiceLevel" show-overflow-tooltip></el-table-column>
        <el-table-column label="入职时间" prop="employTime" width="120px"></el-table-column>
        <el-table-column label="更新人" prop="lastUpdatedBy"></el-table-column>
        <el-table-column label="更新时间" prop="lastUpdateDate" width="160px"></el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-edit
      ref="content"
      :visible.sync="dialogVisible"
      :customerServiceLevelList="customerServiceLevelList"
      :responsibleDepartmentList="responsibleDepartmentList"
      :rowData="rowData"
      :storeList="dialogStoreList"
      @success="onSearch"
      v-if="dialogVisible"
    ></add-edit>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import addEdit from "./components/add&edit/add&edit";
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'

export default {
  mixins: [tableMixin, pagePathMixin],
  components: { addEdit },
  data() {
    return {
      form: {
        storeName: "",
        workJobs: "",
        customerServiceLevel: "",
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      multipleSelection: [],
      //客服等级
      customerServiceLevelList: [],
      //责任部门
      responsibleDepartmentList: [],
      //岗位
      workJobsList: [],
      //客服等级
      customerServiceLevelList: [],
      queryCriteria: [],
      searchFormData: [],
      dialogStoreList: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.getCustomerServiceLevel();
    this.getUserStoreList();
    this.getWorkJobs();
    this.queryCriteriaList();
    this.$set(this.form, "storeId", "");
    this.onSearch();
  },
  methods: {
    onSearch() {
      let userName = this.form.userName && this.form.userName.split(" ").length > 1000; //真实姓名
      if (userName) {
        this.$message.error("已超过1000条，请核对！");
        return;
      }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "workNo", //工号
          val: [this.form.workNo ? this.form.workNo : ""],
          op: "in",
        },
        {
          attributeName: "userName", //真实姓名
          val: this.form.userName ? this.form.userName.split(' ') : [],
          op: "in",
        },
        {
          attributeName: "storeFullName", //店铺
          val: [this.form.storeFullName && this.form.storeFullName != "全部" ? this.form.storeFullName : ""],
          op: "in",
        },
        {
          attributeName: "platCustomerServiceId", //平台客服ID
          val: [this.form.platCustomerServiceId ? this.form.platCustomerServiceId : ""],
          op: "in",
        },
        {
          attributeName: "workJobs", //岗位
          val: [this.form.workJobs ? this.form.workJobs : ""],
          op: "in",
        },
        {
          attributeName: "customerServiceLevel", //客服等级
          val: [this.form.customerServiceLevel ? this.form.customerServiceLevel : ""],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      let userName = this.form.userName && this.form.userName.split(" ").length > 1000; //真实姓名
      if (userName) {
        this.$message.error("已超过1000条，请核对！");
        return;
      }
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      this.loading = true;
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "qualityCheckServiceConfig";
      data.queryMatch = filter || [];
      data.hasCount = "Y";
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/qualityCheckServiceConfig`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
          this.getStoreName();
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {
        storeName: "",
        workJobs: "",
        customerServiceLevel: "",
      };
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.groupAttr = "storeFullName";
      data.reportCode = "qualityCheckServiceConfig";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeList = data;
      });
    },
    //岗位
    getWorkJobs() {
      let data = { ...this.currencyForm };
      data.groupAttr = "workJobs";
      data.reportCode = "qualityCheckServiceConfig";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.workJobsList = data;
      });
    },
    //客服等级
    getCustomerServiceLevel() {
      let data = { ...this.currencyForm };
      data.groupAttr = "customerServiceLevel";
      data.reportCode = "qualityCheckServiceConfig";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.customerServiceLevelList = data;
      });
    },
    // 新增 弹出dialog
    add() {
      this.rowData = null;
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    async delRow(row) {
      if (!this.multipleSelection.length && !row) {
        this.$message.error("请选择后在进行操作");
        return;
      }
      let status = await this.$confirm("是否确认删除？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let data = this.multipleSelection.length ? this.multipleSelection.map((v) => v.userId) : [row.userId];
      let res = await this.$q.qualityTestingManage.customerServiceDel({ data: data });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.onSearch();
    },
    queryCriteriaList() {
      this.$q.qualityTestingManage.queryCriteriaList().then((res) => {
        let { customerServiceLevelList, responsibleDepartmentList } = res.data || {};
        this.customerServiceLevelList = customerServiceLevelList;
        this.responsibleDepartmentList = responsibleDepartmentList;
      });
    },
    //弹窗店铺下拉
    getUserStoreList() {
      this.$q.qualityTestingManage.userStoreList().then((res) => {
        this.dialogStoreList = res.data;
      });
    },
    //导入
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/customerServicePersonnelImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "客服人员配置导入.xlsx",
          appCode: "ec-pc-new",
          reportName: "qualityCheckServiceConfigImport",
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
